import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec cloud_computing_tabs p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">
              Our NLP Development <span>Tech Stack</span>
            </h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              Building performant NLP solutions using new-age, efficient
              technologies to help businesses operate better and grow faster.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Programing Language">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/language/Java.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Java</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/language/python.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Python</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/language/r-language.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>R-Language</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Frameworks">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/frameworks/fast_text.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Fast Text</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/frameworks/gensim.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Gensim</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/frameworks/hugging_face_transformers.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Hugging Face Transformers</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/frameworks/keras.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Keras</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/frameworks/natural_language_toolkit.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Natural Language Toolkit</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/frameworks/PyTorch.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>PyTorch</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/frameworks/SpaCy.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>SpaCy</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/frameworks/TensorFlow.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>TensorFlow</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Machine and Deep learning">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/machine/light_gbm.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>LightGBM</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/machine/Scikit-learn.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Scikit-Learn</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/machine/XGBoost.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>XGBoost</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Annotation Tools">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/annotation/Label_box.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Labelbox</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/annotation/Prodigy.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Prodigy</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Big Data">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/big/Apache_Spark.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Apache Spark</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/big/hadoop.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Hadoop</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/big/kafka.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Kafka</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="6" title="Cloud Platforms">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/cloud/AWS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/cloud/Azure.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/cloud/Google_Cloud_Platform.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud Platform</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="7" title="Database">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/database/Elastic_search.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Elasticsearch</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/database/MongoDB.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/database/PostgreSQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>PostgreSQL</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="8" title="DevOps">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/devops/docker.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Docker</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/devops/GitHub_Actions.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>GitHub Actions</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/devops/Jenkins.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Jenkins</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/nlp/devops/kubernets.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>kubernets</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
